<ng-template #dialogContant>
    <h2 matDialogTitle>אזהרה</h2>
    <mat-dialog-content>
        <p [innerHTML]="currentRequest.msg"></p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-button matDialogClose color="primary">סגור</button>
    </mat-dialog-actions>
</ng-template>